import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  toastSuccessMessage,
  InputValidationConstants,
  InputControl,
  Loading,
  LogotypeBelkaPoziom,
} from "wup-module1-base";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { AuthService } from "../../Services";
import "./Login.css";
import { toast } from "react-toastify";

function PasswordReset() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    AuthService.checkLink(hash)
      .then((response) => {
        setUserId(response.data.clientId);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const resetPassword = (data) => {
    setIsSubmitting(true);

    const requestData = {
      clientId: userId,
      password: getValues("password"),
      password_confirmation: getValues("password_r"),
      hash: hash,
    };

    AuthService.resetPassword(requestData)
      .then((response) => {
        if (response) {
          setIsSubmitting(false);
          toastSuccessMessage("Hasło ustawione pomyślnie!");
          navigate("/login");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Coś poszło nie tak");
        setIsSubmitting(false);
      })
      .finally(() => {});
  };

  return (
    <>
      {userId ? (
        <Form onSubmit={handleSubmit(resetPassword)}>
          <Row>
            <Col md={12} className="login-image-col">
              <img
                className="d-inline-block image-fluid login-image"
                src={LogotypeBelkaPoziom}
                alt="Logo MAŁOPOLSKA"
              />
            </Col>
            <Col md={12} className="login-header-col">
              <div className="login-header-text">
                <h1 className="login-header d-inline-block align-self-end mb-1">
                  Ponowne ustawienie hasła
                </h1>
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6}>
              <InputControl
                id="password"
                label="Wpisz hasło"
                type="password"
                refs={{
                  ...register("password", {
                    required: InputValidationConstants.required,
                    validate: (value) => {
                      if (!value) {
                        return "To pole jest wymagane.";
                      }
                      const passwordRegex =
                        /^(?=.*[0-9].*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z].*[A-Z])(?=.*[a-z]).{12,}$/;
                      if (!passwordRegex.test(value)) {
                        return "Hasło powinno składać się z przynajmniej 12 znaków w tym dwóch cyfr, jednego znaku specjalnego oraz dwóch dużych liter.";
                      }

                      return null;
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
            <Col md={6}>
              <InputControl
                id="password_r"
                label="Powtórz hasło"
                type="password"
                refs={{
                  ...register("password_r", {
                    required: InputValidationConstants.required,
                    validate: (value) => {
                      if (!value) {
                        return "To pole jest wymagane.";
                      }
                      if (value !== getValues("password")) {
                        return "Hasła powinny być takie same.";
                      }

                      return null;
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="my-0">
            <Col className="text-right">
              <Button
                type="submit"
                variant="login-submit"
                disabled={isSubmitting}
                className="px-5"
              >
                {isSubmitting ? (
                  <Loading size="sm" className="p-0" variant="light" />
                ) : (
                  "Zatwierdź"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <div>
          {" "}
          {!isLoading && (
            <>
            <Row>
              <Col md={12} className="login-image-col">
                <img
                  className="d-inline-block image-fluid login-image"
                  src={LogotypeBelkaPoziom}
                  alt="Logo MAŁOPOLSKA"
                />
              </Col>
              <Col md={12} className="login-header-col">
                <div className="login-header-text">
                  <h1 className="login-header d-inline-block align-self-end mb-1">
                    Ponowne ustawienie hasła
                  </h1>
                </div>
              </Col>
            </Row>
            <Row>Link jest nieaktywny albo hasło zostało już ustawione!</Row>
            <Row className="my-0">
              <Col className="text-right">
                <a
                  className="mr-3 text-dark text-underline cursor-pointer"
                  onClick={() => navigate("/login")}
                >
                  Powrót
                </a>
              </Col>
            </Row>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default PasswordReset;
